import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBG6S0hZb8lLIUV-XD4tiw4OUlQLWbhZxA",

  authDomain: "techvalidatefix.firebaseapp.com",

  projectId: "techvalidatefix",

  storageBucket: "techvalidatefix.appspot.com",

  messagingSenderId: "397664926987",

  appId: "1:397664926987:web:9ba6bfffba9338662ef60e",

  measurementId: "G-2CSDQSZ5PY",
});

const db = firebaseApp.firestore();

export default db;
